import { isEqual } from 'lodash';

export const ObjectControlMixin = {
    props: {
        /** @model */
        value: {
            type: Object,
            default: () => ({})
        }
    },
    data: (vm) => ({
        model: vm.createSettings()
    }),
    watch: {
        valueResolved: {
            deep: true,
            immediate: true,
            handler(value) {
                if (isEqual(value, this.model)) {
                    return;
                }
                this.model = this.createSettings(value);
            }
        },
        model: {
            deep: true,
            handler(settings) {
                if (isEqual(settings, this.valueResolved)) {
                    return;
                }
                this.emitChanges(settings);
            }
        }
    },
    methods: {
        /**
         * function for creating emitted data
         *
         * @param {Object} settings
         * @return {Object}
         */
        createSettings(settings = {}) {
            return { ...settings };
        },
        emitChanges(settings) {
            const result = this.createSettings(settings);
            this.$emit('input', result);
            this.$emit('change', result);
        }
    }
};
